import { render, staticRenderFns } from "./c-spendings-modal.vue?vue&type=template&id=6770037a&scoped=true&"
import script from "./c-spendings-modal.vue?vue&type=script&lang=ts&"
export * from "./c-spendings-modal.vue?vue&type=script&lang=ts&"
import style0 from "./c-spendings-modal.vue?vue&type=style&index=0&id=6770037a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6770037a",
  null
  
)

export default component.exports